<template>
  <div>
    <div class="input-group">
      <div class="custom-file form-control">
        <input type="file"
               class="custom-file-input"
               :id="name"
               :aria-describedby="name + 'Addon'"
               @change="handleInputFileChange"
        />
        <label class="custom-file-label" :for="name"></label>
      </div>
      <div class="input-group-append" v-if="isShowAppendButton">
        <button class="btn btn-outline-secondary" type="button" :id="name+'ChangeFile'"
                @click="handleChangeAnotherFile">
          {{ $t('profile.label.file_input_exists') }}
        </button>
        <button class="btn btn-outline-secondary" type="button" :id="name+'ResetFile'" @click="resetFileInput">
          {{ $t('profile.label.file_input_mn') }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import $ from "jquery";

export default {
    name: "FileInput",
    props: {
        value: {
            type: File,
        },
        name: {
            type: String,
        },
    },
    data() {
        const inputFileButtonText = "\"" + this.$t('profile.label.file_input_new') + "\"";
        return {
            el: null,
            isShowAppendButton: false,
            inputFileStyle: "<style id='custom-input-file'>.custom-file-label::after {content: " + inputFileButtonText + " !important;background-color: white !important}</style>",
        };
    },
    components: {},
    methods: {
        handleInputFileChange(e) {
            const el = e.target;
            this.el = el;
            this.isShowAppendButton = true;
            $(el).next(".custom-file-label").toggleClass('changed', true);
            const files = e.target.files;
            if (files && files.length > 0) {
                const validFile = this.getValidFileName(files[0]);
                let fileName = validFile.name;
                $(el).next(".custom-file-label").html("<div class='file-label-container'> <i class=\"fas fa-file\"/></i><span class=''>" + fileName + "</span></div>");
                this.$emit('input', validFile);
            }
            this.$emit('onChangeFileInput');
        },

        handleChangeAnotherFile() {
            const el = this.el;
            this.resetFileInput();
            $(el).trigger("click");
        },
        getValidFileName(file) {
          // Replace character "\" and "/" to "_" of fileName
          return new File([file], file.name.replace(/[\\/:]/g, '_'), { type: file.type });
        },
        resetFileInput() {
            const el = this.el;
            this.isShowAppendButton = false;
            $(el).next(".custom-file-label").removeClass("changed")
            this.inputValue = null;
            $(el).val(null);
            $(el).next(".custom-file-label").html("");
            this.$emit('input', null);
        },
    },

    mounted() {
        if (!$(`#custom-input-file`).length) {
            $('body').append(this.inputFileStyle);
        }
    },
};
</script>

<style scoped>
.form-control {
    border: none;
}

.custom-file-label {
    border-radius: 0;
    background: none;
}

.input-group-append button {
    border-color: #ddd;
    background-color: white;
}

.input-group-append button:hover {
    background-color: white;
    color: #6c757d;
}

.custom-file-input:focus ~ .custom-file-label {
    border-color: #ced4da;
    box-shadow: unset !important;
}

label.custom-file-label.changed:after {
    display: none !important;
}
</style>
